// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"8a5a7215","321":"dea096b6","323":"352b3c55","485":"f1a5fd9a","526":"3ad9ad8b","592":"639eda9f","773":"c24b4a9e","834":"c42226f1"}[chunkId] + ".chunk.js";
};